import React from 'react';
import { cn } from '../lib/utils';

export function ChartCard({ title, subtitle, actions, children, className }) {
  return (
    <div className={cn('surface-card p-4 sm:p-5 flex flex-col', className)}>
      <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
        <div>
          <h3 className="text-sm font-semibold">{title}</h3>
          {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
        </div>
        {actions}
      </div>
      <div className="flex-1 min-h-0">{children}</div>
    </div>
  );
}
